<template>
  <div class="top-header">
    <b-breadcrumb :items="crumbs" v-if="!isHome && !objectStoreOnly" />
    <div class="pull-right flex topmenu__right">
        <div class="flex">
            <div ref="actions" v-if="!objectStoreOnly">
                <div class="notifications header__icon" @click="showActions = !showActions" :class="{active: showActions}">
                    <i class="fa fa-rocket" aria-hidden="true"></i>
                </div>
                <fActionsMenu v-if="showActions" />
            </div>
            <div ref="tips">
                <div class="notifications header__icon" @click="showTips = !showTips" :class="{active: showTips}">
                    <i class="fa fa-graduation-cap" aria-hidden="true"></i>
                </div>
                <fTipsTrics v-if="showTips" />
            </div>
            <div ref="message">
                <div class="notifications header__icon" @click="showMessages = !showMessages" :class="{active: showMessages}">
                    <i class="fa fa-bell-o" aria-hidden="true"></i>
                    <span class="new__message" v-if="newMessages && newMessages.length > 0"></span>
                </div>
                <fMessageCenter v-if="showMessages" :newMessages="newMessages" :readMessages="readMessages" />
            </div>
            <!-- <div class="support header__icon" @click="goToSupport()">
                <i class="fa fa-life-ring" aria-hidden="true"></i>
                <i class="fa fa-external-link" aria-hidden="true"></i>
            </div> -->
        </div>
        <div class="usage__top" @click="gotoUsage()" v-if="!objectStoreOnly || isCustomerOwner()">
            Usage<br>
            <span v-if="hasToken">
                <strong v-if="hasUsageData && currentMonthUsage && currentMonthUsage.total && currentMonthUsage.total.total">€{{ currentMonthUsage.total.total.toFixed(2) }}</strong>
                <small v-else-if="hasUsageData">No data</small>
                <small v-else-if="hasUsageError">No data</small>
                <small v-else><svg-spinner class="spinner"/></small>
            </span>
            <strong v-else>€0.00</strong>
        </div>
        <fSidebarTeamProject :key="projectKey" />
    </div>
        <!-- <div class="basket">
              <h3><i class="fas fa-ticket"></i> Fuga Credits <span class="pull-right">1.250</span></h3>
              <strong>Tips to earn more credits:</strong>
              <ul class="list-unstyled basket__list">
                  <li>
                      <div>My level of expertise</div>
                      <div>50</div>
                  </li>
                  <li>
                      <div>Add users to your team</div>
                      <div>50</div>
                  </li>
                  <li>
                      <div>Add voucher code</div>
                      <div>?</div>
                  </li>
                  <li>
                      <div>Write a tutorial</div>
                      <div>?</div>
                  </li>
              </ul>
              <div class="basket__footer">
                    <a href="" class="pull-right">Buy Goodies</a>
              </div>
        </div> -->
    </div>
</template>

<script>
const fSidebarTeamProject = () => import('@/components/menu/f-sidebar-team-project2');
const fMessageCenter = () => import('@/components/menu/f-message-center');
const fTipsTrics = () => import('@/components/menu/f-tips-trics');
const fActionsMenu = () => import('@/components/menu/f-actions');
const svgSpinner = () => import('@/components/svg/svg-spinner');

export default {
  data() {
      return {
          showMessages: false,
          readMessages: false,
          showTips: false,
          showActions: false,
          currentUser: this.$store.state.user.info,
      }
  },

  computed: {
    crumbs: function() {
        let pathArray = this.$route.path.split('/');
        pathArray.shift();
        let pathArrayRegion = pathArray.find((path) => path === 'ams' || path === 'fra' || path === 'core');
        pathArray = pathArray.filter(path => path != '' && path !== 'ams' && path !== 'fra' && path !== 'core');

        let isKubernetesPages = false;
        if (this.$router.currentRoute.meta.sidebar && this.$router.currentRoute.meta.sidebar === 'emk') {
            isKubernetesPages = true;
        }

        let breadcrumbs = pathArray.reduce((breadcrumbArray, path, idx) => {
            let toPath =  '/' + path;
            if (idx != 0 && !isKubernetesPages) {
                toPath = '/'+ pathArray[0] + '/' + pathArrayRegion + '/' + path + '/';
            } else if (idx != 0 && isKubernetesPages) {
                toPath = '/'+ pathArray[0] + '/' + path + '/';
            } else  {
                toPath = '/' + path + '/';
            }
            breadcrumbArray.push({
                path: path,
                to: toPath,
                text: decodeURIComponent(path)
            });
            return breadcrumbArray;
        }, []);

        breadcrumbs.unshift({
            path: '/',
            text: 'Home',
            to: '/'
        });

        return breadcrumbs;
    },

    currentMonthUsage() {
        let data = this.$store.state.usage.currentMonth;
        if (data) {
            this.isLoading = false;
            return data;
        } else {
            this.isLoading = true;
            return false;
        }
    },

    newMessages() {
        let data = this.$store.state.notification.list;
        let newMessages = []
        this.readMessages = []
        data.forEach((message) => {
            if (message.seen_at.length > 0 && message.seen_at.find(item => item.user_id === this.currentUser.id)) {
                this.readMessages.push(message)
            } else {
                newMessages.push(message)
            }
        });
        return newMessages;
    },

    projectKey() {
        return this.$store.state.project.updateKey;
    },
  },

  methods: {
    gotoUsage() {
        if (this.$router.currentRoute.name !== 'billing') {
            this.$router.push({ name: 'billing' });
        }
    },
  },

  created() {
    window.addEventListener('click', (e) => {
        if (this.$refs && this.$refs.message) {
            if (!this.$refs.message.contains(e.target)){
                this.showMessages = false;
            } else {
                this.showMessages = true;
            }
            if (!this.$refs.tips.contains(e.target)){
                this.showTips = false;
            } else {
                this.showTips = true;
            }
            if (!this.objectStoreOnly) {
                if (!this.$refs.actions.contains(e.target)){
                    this.showActions = false;
                } else {
                    this.showActions = true;
                }
            }
        }
    })
  },

    components: {
        fSidebarTeamProject,
        fMessageCenter,
        fTipsTrics,
        fActionsMenu,
        svgSpinner,
    }
}
</script>
<style scoped="scoped">
.breadcrumb {
    margin: 20px 0 0;
}
.usage__top {
    padding: 16px 20px 10px 20px;
    text-align: left;
    margin: 0 0 0 20px;
    border-left: 1px solid #dae1e7;
    cursor: pointer;
    position: relative;
}
.top-header {
    height: 80px;
    padding: .75rem 30px;
    text-transform: unset
}

.header__icon {
    padding: 20px 10px;
    font-size: 20px;
    color: #dae1e7;
    float: left;
    color: #dae1e7;
    border-radius: 4px;
    cursor: pointer;
    position: relative;
}
.header__icon > .fa {
    font-size: 20px;
}
.header__icon > .fa-external-link {
    font-size: 10px;
    position: absolute;
    top: 0;
    right: 0;
    margin: 20px 2px 0 0;
}
.header__icon:hover,
.header__icon.active {
    background: rgba(37,179,184,.3);
    color: #25b3b8;
}


.animate_credit .basket {
    animation: shakeCart .4s ease-in-out forwards;
    z-index: 9999;
}

.basket {
  position:fixed;
  top:20px;
  right:55px;
  width:350px;
  background:#1d263c;
  border-top-left-radius:5px;
  border-bottom-left-radius:5px;
  padding: 20px 20px 90px 20px;
  z-index: 9;
  color: #fff;
  text-transform: none;
  box-shadow: inset 0 0 5px #000000;
  display: none;
}
.show__credits .basket {
    display: block;
}
.basket i {
    font-size:25px;
    color:white;
}

@keyframes shakeCart {
  25% {
    transform:translateX(6px)
  }
  50% {
    transform:translateX(-4px);
  }
  75% {
    transform:translateX(2px);
  }
  100% {
    transform:translateX(0);
  }
}

.basket h3,
.basket__list li {
    border-bottom: 1px solid #fff;
}
.basket h3 {
    margin: -20px -20px 20px -20px;
    padding: 20px;
}
.basket__list li {
    padding: 10px 0;
    overflow: auto;
}
.basket__list div {
    width: 50%;
    float: left;
}
.basket__list div:nth-child(2) {
    text-align: right;
}
.basket__footer {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 20px;
    width: 100%;
}
.notifications {
    position: relative;
}
.new__message {
    display: block;
    position: absolute;
    height: 13px;
    width: 13px;
    background: red;
    border-radius: 50%;
    bottom: 20px;
    right: 5px;
    border: 3px solid #fff;
}
.topmenu__right {
    margin: -7px -7px 0 0;
}
</style>
